import posthog from 'posthog-js';

import { post, logError, user } from 'utils';

export default function logout(callback = () => {}) {
  user.logout();

  post({ apiKey: 'auth.logout', ignoreReadModeCheck: true })
    .then(({ data }) => {
      posthog.reset();
      callback(null, data);
    })
    .catch(() => {
      const error = new Error('Logout API failed');
      logError(error);
      callback();
    });
}
